<template>
    <div class="center-box">
        <div class="container">
            <!-- 导航栏 -->
            <div class="center-nav">
                <el-scrollbar
                    tag="ul"
                    :native="false"
                    class="center-nav-scrollbar">
                    <el-menu
                        mode="vertical"
                        class="center-nav-scrollbar-menu"
                        :default-active="$route.path"
                        background-color="#fff"
                        active-text-color="#FF6700"
                        router>
                        <!-- 首页管理 -->
                        <el-menu-item index="/center/main">
                            <template #title>
                                <!-- <div>首页管理</div> -->
                                <div>{{$t("message.center.nav1")}}</div>
                            </template>
                        </el-menu-item>
                        <!-- 我的商品 -->
						 <!-- v-if="power.includes(0) || character_id==2 || character_id==3" -->
                        <el-menu-item index="/center/goods" v-if="power.includes(0) || power.includes(16)">
                            <template #title>
                                <!-- <div>我的商品</div> -->
                                <div>{{$t("message.center.nav2")}}</div>
                            </template>
                        </el-menu-item>
                        <!-- 我的收藏 -->
                        <el-menu-item index="/center/collection" v-if="power.includes(24) || power.includes(0) || power.includes(17) || power.includes(111) ">
                            <template #title>
                                <!-- <div>我的收藏</div> -->
                                <div>{{$t("message.center.nav18")}}</div>
                            </template>
                        </el-menu-item>
                        <!-- 管理子公司/分行 -->
                        <el-menu-item index="/center/branch" v-if="power.includes(0) || power.includes(1)">
                            <template #title>
                                <!-- <div>管理子公司/分行</div> -->
                                <div>{{$t("message.center.nav3")}}</div>
                            </template>
                        </el-menu-item>
                        <!-- 收货地址管理 -->
                        <el-menu-item index="/center/address" v-if="power.includes(0) || power.includes(3) || power.includes(111)">
                            <template #title>
                                <!-- <div>收货地址管理</div> -->
                                <div>{{$t("message.center.nav4")}}</div>
                            </template>
                        </el-menu-item>
                        <!-- 管理部门 -->
                        <el-menu-item index="/center/department"  v-if="power.includes(0) || power.includes(2)">
                            <template #title>
                                <!-- <div>管理部门</div> -->
                                <div>{{$t("message.center.nav5")}}</div>
                            </template>
                        </el-menu-item>
                        <!-- 管理用户 -->
                        <el-menu-item index="/center/member" v-if="power.includes(0) || power.includes(5)">
                            <template #title>
                                <!-- <div>管理用户</div> -->
                                <div>{{$t("message.center.nav6")}}</div>
                            </template>
                        </el-menu-item>
                        <!-- 资料修改 -->
                        <el-menu-item index="/center/data" v-if="power.includes(0)">
                            <template #title>
                                <!-- <div>资料修改</div> -->
                                <div>{{$t("message.center.nav7")}}</div>
                            </template>
                        </el-menu-item>
                        <!-- 密码修改 -->
                        <el-menu-item index="/center/pwd" v-if="power.includes(0) || power.includes(4) || power.includes(111)">
                            <template #title>
                                <!-- <div>密码修改</div> -->
                                <div>{{$t("message.center.nav8")}}</div>
                            </template>
                        </el-menu-item>
                        <!-- 支援中心 -->
                        <!-- <el-menu-item index="/center/callcenter"
                            v-if="character_id == 2 || character_id == 6 || power.includes(7)">
                            <template #title>
                                <div>{{$t("message.center.nav19")}}</div>
                            </template>
                        </el-menu-item> -->
                        <!-- 报价车 -->
                        <el-menu-item index="/center/quoteCart"   v-if="power.includes(0) || power.includes(18) || power.includes(111)">
                            <template #title>
                                <!-- <div>报价车</div> -->
                                <div>{{$t("message.center.nav9")}}</div>
                            </template>
                        </el-menu-item>
                        <!-- 报价车订单 -->
                        <el-menu-item index="/center/quoteOrder" v-if="power.includes(0) || power.includes(19) || power.includes(111)">
                            <template #title>
                                <!-- <div>报价车订单</div> -->
                                <div>{{$t("message.center.nav10")}}</div>
                            </template>
                        </el-menu-item>
                        <!-- 购物车 -->
                        <el-menu-item index="/center/cart" v-if="power.includes(0) || power.includes(20) || power.includes(111)">
                            <template #title>
                                <!-- <div>购物车</div> -->
                                <div>{{$t("message.center.nav11")}}</div>
                            </template>
                        </el-menu-item>
                        <!-- 订单状态 -->
						<!-- character_id !== 5 && -->
						<!-- v-if="character_id !== 6" -->
                        <el-menu-item index="/center/orderStatus"  v-if="power.includes(0) || power.includes(11) || power.includes(111)">
                            <template #title>
                                <!-- <div>订单状态</div> -->
                                <div>{{$t("message.center.nav12")}}</div>
                            </template>
                        </el-menu-item>
                        <!-- 支付状态 -->
						<!-- character_id !== 5 && -->
						<!-- v-if="character_id !== 6" -->
                        <el-menu-item index="/center/payStatus"  v-if="power.includes(0) || power.includes(12)|| power.includes(111)">
                            <template #title>
                                <!-- <div>支付状态</div> -->
                                <div>{{$t("message.center.nav20")}}</div>
                            </template>
                        </el-menu-item>
                        <!-- 订单管理 -->
						<!-- -if="powerPrice && character_id !== 3 && character_id !== 5 && character_id !== 6" -->
						 <!-- v-if="powerPrice && character_id !== 3  && character_id !== 6" -->
                        <el-menu-item index="/center/order" v-if="power.includes(0) || power.includes(13)|| power.includes(111)">
                            <template #title>
                                <!-- <div>订单管理</div> -->
                                <div>{{$t("message.center.nav13")}}</div>
                            </template>
                        </el-menu-item>
                        <!-- 数据分析 -->
						<!-- v-if="powerPrice && !power.includes(111) && character_id !== 6" -->
                        <el-menu-item index="/center/analysis" v-if="power.includes(0) || power.includes(14)">
                            <template #title>
                                <div>{{$t("message.center.nav14")}}</div>
                            </template>
                        </el-menu-item>
                        <!-- 月结单下载 -->
						<!-- v-if="powerPrice && character_id!=3 && character_id!=4 && character_id!=6" -->
                        <el-menu-item index="/center/statement" v-if="power.includes(0) || power.includes(15)">
                            <template #title>
                                <!-- <div>月结单下载</div> -->
                                <div>{{$t("message.center.nav17")}}</div>
                            </template>
                        </el-menu-item>
                    </el-menu>
                </el-scrollbar>
            </div>
            <!-- 视口 -->
            <div class="center-view">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapState({
            islogin: state => state.user.islogin,
            power: state => state.user.power,
            character_id: state => state.user.character_id,
        }),
        ...mapGetters([
            'powerPrice',
        ])
    },
}
</script>

<style scoped>
/* 组件盒子 */
.center-box{
    height: 100%;
    background-color: #f5f5f5;
}
/* 导航栏容器 */
.center-nav{
    position: fixed;
    top: 0;
    height: 100%;
    padding-top: 51px;
    z-index: 10;
}
/* 导航栏 */
.center-nav-scrollbar{
    width: 180px;
    height: 100%;
    background-color: #f5f5f5;
}
.center-nav>>>.el-scrollbar__wrap{
    overflow-x: hidden;
}
.center-nav>>>.el-scrollbar__thumb{
    background-color: #fe8729;
}
.center-nav-scrollbar-menu{
    padding: 40px 0;
}

/* 视口 */
.center-view{
    padding: 40px 0 40px 200px;
    z-index: 8;
}
</style>
